import React from "react";
import { Login } from "@/pages/login";
import { LoginOkta } from "@/pages/login-okta";
import { RiskAnalysis } from "@/pages/risk-analysis";
import { Settings } from "@/pages/settings";
import { FRE } from "@/pages/FRE";
import { Ask } from "@/pages/ask";
import { Draft } from "@/pages/draft";
import { Configurations } from "@/pages/configurations";
import NewClause from "@/pages/draft/new-clause";
import RedraftClause from "@/pages/draft/redraft-clause";
import { ForgotPassword } from "@/pages/forgot-password";
import { ChatEmptyRegular, DocumentSearchRegular, DraftsRegular, WrenchRegular } from "@fluentui/react-icons";

export const ROUTE_NAMES = [
  "login",
  "login/okta",
  "risk-analysis",
  "settings",
  "FRE",
  "questions",
  "revisions",
  "revisions/new-clause",
  "revisions/redraft-clause",
  "configurations",
  "forgot-password",
] as const;

export const TABS_DATA = {
  "risk-analysis": { title: "Playbooks", Icon: DocumentSearchRegular },
  questions: { title: "Questions", Icon: ChatEmptyRegular },
  revisions: { title: "Revisions", Icon: DraftsRegular },
  configurations: { title: "Configurations", Icon: WrenchRegular },
} as const;

export type RouteName = (typeof ROUTE_NAMES)[number];
export type TabName = keyof typeof TABS_DATA;

export interface Route {
  name: RouteName;
  component: React.ComponentType<any>;
  isPublic: boolean;
}

export const routes: Route[] = [
  {
    name: "login",
    component: Login,
    isPublic: true,
  },
  {
    name: "login/okta",
    component: LoginOkta,
    isPublic: true,
  },
  {
    name: "forgot-password",
    component: ForgotPassword,
    isPublic: true,
  },
  {
    name: "risk-analysis",
    component: RiskAnalysis,
    isPublic: false,
  },
  {
    name: "settings",
    component: Settings,
    isPublic: false,
  },
  {
    name: "FRE",
    component: FRE,
    isPublic: true,
  },
  {
    name: "questions",
    component: Ask,
    isPublic: false,
  },
  {
    name: "revisions",
    component: Draft,
    isPublic: false,
  },
  {
    name: "revisions/new-clause",
    component: NewClause,
    isPublic: false,
  },
  {
    name: "revisions/redraft-clause",
    component: RedraftClause,
    isPublic: false,
  },
  {
    name: "configurations",
    component: Configurations,
    isPublic: false,
  },
];
